import { Agent } from '../types/agent';

export const agents: Agent[] = [
  {
    id: 'algorand-agent',
    name: 'Algorand Agent',
    description: 'AI assistant specialized in Algorand blockchain',
    avatar: '/images/Agent.png',
    enabled: true,
    selected: true
  },
  {
    id: 'blank-agent',
    name: 'Blank Agent',
    description: 'Feed and hydrate it with your documents, links and files',
    avatar: '/images/bot-logo.jpg', // Reusing existing image
    enabled: false,
    selected: false
  },
  {
    id: 'goplausible-agent',
    name: 'GoPlausible Agent',
    description: 'Agent to issue DID powered Verifiable Credentials.',
    avatar: '/images/goPlausible-logo-type-v.png', // Reusing existing image
    enabled: false,
    selected: false
  },
  {
    id: 'vestige-agent',
    name: 'Vestige Agent',
    description: 'Analytics and insights for Algorand assets',
    avatar: '/images/vestige-logo.png', // Reusing existing image
    enabled: false,
    selected: false
  },
  {
    id: 'tinyman-agent',
    name: 'Tinyman Agent',
    description: 'Specialized in Tinyman DEX and liquidity pools',
    avatar: '/images/tinyman-logo.png', // Reusing existing image
    enabled: true,
    selected: false
  },
  {
    id: 'ultrade-agent',
    name: 'Ultrade Agent',
    description: 'Trading and market analysis for Algorand assets',
    avatar: '/images/ultrade_logo.jpg', // Reusing existing image
    enabled: false,
    selected: false
  },
  
  {
    id: 'folks-agent',
    name: 'Folks Finance Agent',
    description: 'Folks Finance Defi lending and borrowing',
    avatar: '/images/folks-logo.png', // Reusing existing image
    enabled: false,
    selected: false
  },
  
  {
    id: 'nfd-agent',
    name: 'NFDomains Agent',
    description: 'All NFDomains APIs and SDK functionalities as an agent',
    avatar: '/images/nfd-logo.png', // Reusing existing image
    enabled: false,
    selected: false
  },
  
  {
    id: 'deflex-agent',
    name: 'Deflex Agent',
    description: 'Deflex engine (powering HayStack) by TxnLabs as an agent',
    avatar: '/images/haystack-logo.jpg', // Reusing existing image
    enabled: false,
    selected: false
  }
];
